<template>
    <pt-form-list-item label="税务项目：" required >
             <el-button  type="primary" plain @click="selectTax">点击选择税务项目</el-button>
             <wt-input v-model="tax_requry" style="display:none" data-vv-as="税务项目" name="name"  v-validate="'required'"></wt-input>
             <div :class="$style['goods-table-div']" class="page-background" v-if="isHasTaxTable">
                <table :class="$style['specification-table']">
                    <th>
                        <td>项目名称</td>
                        <td>税率</td>
                        <td>单位</td>
                        <td>项目编码</td>
                    </th>
                    <tr >
                        <td>{{taxProject.xmmc}}</td>
                        <td>{{taxProject.rate}}</td>
                        <td>{{taxProject.dw}}</td>
                        <td>{{taxProject.xmbm}}</td>
                    </tr>
                </table>
             </div>
    </pt-form-list-item>
</template>
<script>
export default {
  props: {
    taxRequry: {
      type: String,
      default: null
    },
    taxProject: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isHasTaxTable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tax_requry: this.taxRequry
    }
  },
  methods: {
    selectTax () {
      this.$emit('selectTax')
    }
  }
}
</script>
<style module lang="less">
.specification-table{
    display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row;
        padding: 0!important;
        list-style-type:none;
        border-bottom: 1px solid #C6C9D3;
        color: #818181
    }
    td{
        text-align: center;
        padding: 10px;
    }
}
.goods-table-div{
    margin-top: 10px;
    padding: 10px 20px 30px;
}
</style>
